import { render } from "./editarAdministrador.vue?vue&type=template&id=5f0926f6&scoped=true"
import script from "./editarAdministrador.vue?vue&type=script&lang=js"
export * from "./editarAdministrador.vue?vue&type=script&lang=js"

import "./editarAdministrador.vue?vue&type=style&index=0&id=5f0926f6&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0926f6"]])

export default __exports__